<script setup>
import { onMounted, ref } from "vue";
import { appBarStore } from "@/stores/appBar";
const appBar = appBarStore();
import { permissionsStore } from "@/stores/permissions";
import { apiQuery } from "@/api/j24api";
const permissions = permissionsStore();
const items = ref([]);

permissions.$subscribe(() => {
  buildSidebarItems();
});
function buildSidebarItems() {
  items.value.length = 0;
  allItems.forEach((item) => {
    if (permissions.$state["Elevate-" + item.privName]) {
      items.value.push(item);
    }
  });
}

onMounted(async () => {
  if (appBar.appRunning != "Elevate") {
    appBar.$patch({
      appRunning: "Elevate",
      type: "select",
      header: "Loading Please Wait...",
      items: [],
      selected: "",
      showLock: "yes",
    });
  }
  buildSidebarItems();
  const result = await apiQuery("ELA", "elevatereports", {
    apiAction: "GetLicences",
  });
  if (result.length) {
    // if (!appBar.selected && result.length == 1) {
    //   appBar.$patch({
    //     selected: result[0].name,
    //     selected:
    //   });
    // }
    appBar.$patch({
      items: [...convertLicenseResult(result)],
      header: "Select Licence",
    });
  }
});

function convertLicenseResult(result) {
  const licences = [];
  result.forEach((licence) => {
    licences.push({
      title: licence.name,
      value: licence.name,
    });
  });
  return licences;
}

const allItems = [
  // { title: "Assets", icon: "mdi-archive", link: "AssetsBulkUploader" },

  // {
  //   title: "Report",
  //   icon: "mdi-chart-bar",
  //   link: "ElevateReport",
  //   privName: "Reports",
  //   value: false,
  // },
  {
    title: "Report",
    icon: "mdi-chart-bar",
    link: "ElevateReportV2",
    privName: "Reports",
    value: false,
  },
  {
    title: "License",
    //icon: "mdi-chart-bar",
    icon: "mdi-license",
    link: "ElevateLicence",
    privName: "Reports",
    value: false,
  },
  // {
  //   title: "ESF (Beta)",
  //   icon: "mdi-chart-bar",
  //   link: "ElevateESF",
  //   privName: "SecurityLogs",
  //   value: false,
  // },
  {
    title: "Support",
    icon: "mdi-chat-question",
    link: "ElevateSupport",
    privName: "Reports",
    value: false,
  },
];

// Required to make the router-view reload when user clicks the link again
// See the key value set on <router-view> below.
const randomKey = ref("");
function updateRandom() {
  randomKey.value = (Math.random() + 1).toString(36).substring(7);
}
</script>

<template>
  <v-navigation-drawer permanent width="190" theme="jigsawDark">
    <v-list>
      <!-- <v-list-item link :to="{ name: 'ElevateLicence' }" active-color="#e7541e">
        <template v-slot:prepend>
          <v-img class="mr-2" src="@/assets/elevateIcon.png" width="24"></v-img>
        </template>
        <v-list-item-title> Elevate24 </v-list-item-title>
      </v-list-item> -->

      <template v-for="item in items" :key="item.title">
        <v-list-item
          class="sideBarListItem"
          link
          :to="{ name: item.link }"
          color="#e7541e"
          @click="updateRandom()"
        >
          <template v-slot:prepend>
            <v-icon class="mr-2" size="x-large">{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title class="pl-n4">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
  <v-main>
    <v-container fluid>
      <router-view :key="randomKey" />
    </v-container>
  </v-main>
</template>

<style scoped>
.sideBarListItem :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 10px !important;
}
</style>
